/** 資產類別（對齊 market_symbol.asset_class） */
export const MARKET_ASSET_CLASS = {
  DIGITAL_CURRENCY: 'DIGITAL_CURRENCY',
  FOREX: 'FOREX',
  PRECIOUS_METALS: 'PRECIOUS_METALS',
  COMMODITY_FUTURES: 'COMMODITY_FUTURES',
  STOCK_CN: 'STOCK_CN',
};

export const MARKET_ASSET_CLASS_LABELS = {
  [MARKET_ASSET_CLASS.DIGITAL_CURRENCY]: '數字貨幣',
  [MARKET_ASSET_CLASS.FOREX]: '外匯',
  [MARKET_ASSET_CLASS.PRECIOUS_METALS]: '貴金屬/能源',
  [MARKET_ASSET_CLASS.COMMODITY_FUTURES]: '商品期貨',
  [MARKET_ASSET_CLASS.STOCK_CN]: 'A股',
};

/** 列表頂部 Tab */
export const PRODUCT_TABS = [
  { key: 'ALL', label: '全部' },
  { key: 'TIME_LIMITED', label: '限時', playType: 'TIME_LIMITED' },
  { key: 'FUTURES', label: '交割', playType: 'FUTURES' },
  { key: 'PERPETUAL', label: '永續', playType: 'PERPETUAL' },
  { key: 'COMMODITY', label: '大宗商品', commodityOnly: true },
  { key: 'FOREX', label: '外匯', assetClass: MARKET_ASSET_CLASS.FOREX },
];

/**
 * 新增彈窗：玩法類別（單選）
 * - 限時 / 永續 / 交割 → 數字貨幣
 * - 外匯 → FOREX
 * - 大宗商品 → 非數字貨幣、非外匯（PRECIOUS_METALS 等）
 */
export const CREATE_CATEGORIES = [
  {
    key: 'TIME_LIMITED',
    label: '限時',
    playType: 'TIME_LIMITED',
    assetClass: MARKET_ASSET_CLASS.DIGITAL_CURRENCY,
  },
  {
    key: 'PERPETUAL',
    label: '永續',
    playType: 'PERPETUAL',
    assetClass: MARKET_ASSET_CLASS.DIGITAL_CURRENCY,
  },
  {
    key: 'FUTURES',
    label: '交割',
    playType: 'FUTURES',
    assetClass: MARKET_ASSET_CLASS.DIGITAL_CURRENCY,
  },
  {
    key: 'FOREX',
    label: '外匯',
    playType: 'TIME_LIMITED',
    assetClass: MARKET_ASSET_CLASS.FOREX,
  },
  {
    key: 'COMMODITY',
    label: '大宗商品',
    playType: 'FUTURES',
    commodityOnly: true,
  },
];

export const PLAY_TYPE_LABELS = {
  TIME_LIMITED: '限時',
  FUTURES: '交割',
  PERPETUAL: '永續',
};

export const STATUS_FILTER_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'enabled', label: '啟用' },
  { value: 'disabled', label: '禁用' },
  { value: 'no_order', label: '禁止下單' },
];

export const DEFAULT_FORM = {
  marketSymbolCode: '',
  customName: '',
  showIcon: false,
  conversionRate: '1',
  showPricePerGram: false,
  minOrderAmount: '0',
  maxOrderAmount: '0',
  handlingFeeRate: '0.20',
  durationSeconds: '60',
  payoutOdds: '1.95',
  defaultLeverage: '20',
  maxLeverage: '125',
  stakingTime: '0',
  quickAmounts: '',
  quickRatios: '',
};

export function tabQueryParams(tabKey) {
  const tab = PRODUCT_TABS.find((item) => item.key === tabKey) || PRODUCT_TABS[0];
  const params = {};
  if (tab.playType) {
    params.playType = tab.playType;
  }
  if (tab.assetClass) {
    params.assetClass = tab.assetClass;
  }
  if (tab.commodityOnly) {
    params.commodityOnly = true;
  }
  return params;
}

/** 玩法 Tab 是否無資料（應反灰不可點） */
export function isTabDisabled(tabKey, tabCounts) {
  if (tabKey === 'ALL') {
    return false;
  }
  if (!tabCounts || Object.keys(tabCounts).length === 0) {
    return false;
  }
  return (tabCounts[tabKey] ?? 0) === 0;
}

export function categorySymbolParams(categoryKey) {
  const category = CREATE_CATEGORIES.find((item) => item.key === categoryKey);
  if (!category) {
    return {};
  }
  const params = {};
  if (category.assetClass) {
    params.assetClass = category.assetClass;
  }
  if (category.commodityOnly) {
    params.commodityOnly = true;
  }
  return params;
}

/** 是否為大宗商品資產（排除數字貨幣、外匯） */
export function isCommodityAssetClass(assetClass) {
  if (!assetClass) {
    return false;
  }
  return assetClass !== MARKET_ASSET_CLASS.DIGITAL_CURRENCY
    && assetClass !== MARKET_ASSET_CLASS.FOREX;
}

/** 依玩法類別過濾可選交易對（前端二次過濾） */
export function filterSymbolsForCategory(symbols, categoryKey) {
  const category = CREATE_CATEGORIES.find((item) => item.key === categoryKey);
  if (!category || !Array.isArray(symbols)) {
    return [];
  }
  return symbols.filter((symbol) => {
    const assetClass = symbol?.assetClass;
    if (category.commodityOnly) {
      return isCommodityAssetClass(assetClass);
    }
    if (category.assetClass) {
      return assetClass === category.assetClass;
    }
    return true;
  });
}

export function assetClassLabel(assetClass) {
  return MARKET_ASSET_CLASS_LABELS[assetClass] || assetClass || '—';
}
